import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { User } from '../../core/models/user.model';
import { SendAutologinEmailByBadgeResponse } from 'src/app/shared/models/sendAutologinEmailByBadgeResponse.model';
import { SnackbarService } from 'src/app/core/services/snackbar.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private httpClient: HttpClient,
        private router: Router,
        private snackBarService: SnackbarService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
        this.currentUser = this.currentUserSubject.asObservable();
        
        //this.currentUser.subscribe(user => {
        //    if (!!user)
        //    {
        //        console.log('currentUser isSurveyCompleted updated:', user.isSurveyCompleted);
        //    }
        //});
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    refreshUserFromStorage(): void {
        const user = JSON.parse(localStorage.getItem('user'));
        this.currentUserSubject.next(user);
    }
    
    login(values) {
        let uri;
        if (values.hasOwnProperty('badge')) {
            uri = '/api/login/badge?eventId=' + values.eventId + '&badge=' + values.badge;
        } else if (values.hasOwnProperty('autologin')) {
            uri = '/api/login/autologin?' + values.eventId + '&autologin=' + values.badge;
        } else {
            uri = '/api/login/authenticate';
        }

        return this.httpClient.post(uri, values)
            .pipe(map((data: User) => {
                return this.handleStorage(data);
            }));
    }

    tokenLogin(token: string) {
        return this.httpClient.post('/api/login/token', { token: token })
            .pipe(map((data: User) => {
                return this.handleStorage(data);
            }));
    }

    //Any Data Type
    sendAutologinEmail(eventId: number, badge: string): Observable<any> {
        var url = '/api/login/sendAutologinEmail?eventId=' + eventId + '&badge=' + badge;
        return this.httpClient.get(url);
    }

    sendAutologinEmailByBadge(eventId: number, badge: string): Observable<SendAutologinEmailByBadgeResponse> {
        var subject = new Subject<SendAutologinEmailByBadgeResponse>();
        this.sendAutologinEmail(eventId, badge)
            .pipe(first())
            .subscribe(
                (response) => {
                    subject.next({ success: true, message: response });
                },
                (error) => {
                    subject.next({ success: false, message: error });
                })

        return subject;
    }

    linkAutoLogin(eventId: number, autologin: string) {
        // return this.httpClient.get('/api/login/autoLogin?' + autologin);
        return this.httpClient.post('/api/login/autoLogin', {
            eventId: eventId,
            autologin: autologin
        });
    }

    autologin(eventId: number, autologin: string) {
        let uri = '/api/login/autologin?eventId=' + eventId + '&autologin=' + autologin;
        return this.httpClient.post(uri, { eventId: eventId, autologin: autologin })
            .pipe(map((data: User) => {
                return this.handleStorage(data);
            }));
    }

    linkBadge(user: User, badge: string, eventId: number) {
        return this.httpClient.post('/api/login/link/badge', {
            eventId: eventId,
            userId: user.id,
            badge: badge
        });
    }

    linkUser(user: User, data) {
        return this.httpClient.post('/api/login/link/user', {
            eventId: data.eventId,
            badge: user.badge,
            login: data.login,
            password: data.password,
        });
    }

    forgotPassword(values) {
        return this.httpClient.post('/api/login/forgot', values);
    }

    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        this.currentUserSubject.next(null);
    }

    forceLogout() {
        this.snackBarService.addMessage('The platform is closed. You have been automatically logged out.');
        this.logout();
        this.router.navigate(['/login']);
    }

    /**
     * Updates both the BehaviorSubject and localStorage with a new user object.
     */
    handleStorage(updatedUser: User): User {
        if (updatedUser) {
            const newUser = { ...updatedUser };
    
            // Save to localStorage
            localStorage.setItem('user', JSON.stringify(newUser));
            localStorage.setItem('token', newUser.token);
    
            // Emit new user to all subscribers
            this.currentUserSubject.next(newUser);
    
            //console.log('handleStorage: Updated isSurveyCompleted =', newUser.isSurveyCompleted);
            return newUser;
        }
    
        return null;
    }

}
